/**
 * Convierte el texto a minusculas, remueve tildes/diacriticos y caracteres especiales.
 * Util para cumplir la regla "todos los valores en minusculas, sin tildes y sin simbolos".
 */
export const normalizeText = (text = '') => {
  if (text === null || text === undefined) return '';
  return String(text)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s,]/g, '')
    .trim();
};
